// src/components/products/ProductContainerImage.jsx
import React from "react";

/**
 * Fixed-size product image (see .product-container-image in index.css). No background frame.
 */
const ProductContainerImage = ({
  src,
  alt = "",
  className = "",
  onClick,
}) => {
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      className={`product-container-image ${className}`.trim()}
      loading="lazy"
      decoding="async"
      onClick={onClick}
    />
  );
};

export default ProductContainerImage;
